<template>
  <div v-if="selections.length > 0" :class="$style['table-container']">
    <h3 :class="$style.uppercase">{{ $t('complaintForm.summary_table.summary_headline') }}</h3>
    <div>
      <div :class="[$style.table, $style['table-header']]">
        <span :class="$style['table-header-item']">{{
          $t('complaintForm.summary_table.component')
        }}</span>
        <span :class="$style['table-header-item']">{{
          $t('complaintForm.summary_table.part')
        }}</span>
        <span :class="$style['table-header-item']">{{
          $t('complaintForm.summary_table.error_type')
        }}</span>
        <span :class="$style['table-header-item']">{{
          $t('complaintForm.summary_table.description')
        }}</span>
        <span :class="$style['table-header-item']">{{ $t('complaintForm.claim.quantity') }}</span>
      </div>
      <div :class="$style['table-body']">
        <div v-for="selection in selections" :key="selection.id" :class="$style.table">
          <span>{{ selection.place }}</span>
          <span>{{ selection.part }}</span>
          <span>{{ selection.kind }}</span>
          <span>{{ selection.description }}</span>
          <span>{{ selection.orderQuantity }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selections: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" module>
.uppercase {
  text-transform: uppercase;
}

.table-container {
  margin-top: 3rem;

  .table {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: 1fr 2fr 2fr 4fr 1fr;
    margin-bottom: 0.4rem;

    &-header {
      border-bottom: 1px solid var(--primary);
    }

    &-header-item {
      font-weight: bold;
    }

    &-body {
      span {
        word-break: break-word;
      }
    }
  }
}
</style>
